"use client";
import { useState, useEffect } from 'react';
import { WalletProvider } from './context/WalletContext';
import { ToastProvider } from './context/ToastContext';
import WalletTiles from './components/WalletTiles';
import NetworkToastHandler from './components/NetworkToastHandler';
import { HeyElsaChatWidget } from '@heyelsa/chat-widget';
import { createWalletAdapter } from './adapter';

// Which widget instance this test dApp talks to. Create React App only exposes
// variables prefixed REACT_APP_, matching REACT_APP_SECURITY_DEBUG already used by
// the start:debug script. Set it in .env.local to point at a different widget.
const WIDGET_KEY_ID = process.env.REACT_APP_WIDGET_KEY_ID || 'demo-widget';

function App() {
  const [messagePort, setMessagePort] = useState<MessagePort | null>(null);

  useEffect(() => {
    // Initialize secure adapter (always secure mode). The adapter stores the shared
    // secret the widget sends during the handshake; nothing here needs a copy of it,
    // and secureAdapter.getSharedSecret() is available if that ever changes.
    const secureAdapter = createWalletAdapter({
      maxMessageAge: 3600000, // 1 hour for development
    });
    setMessagePort(secureAdapter.port2);
  }, []);


  return (
    <WalletProvider>
      <ToastProvider>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-100">
          <header className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg">
            <div className="px-4 py-8 text-center">
              <h1 className="text-4xl font-bold mb-2">EVM Chain DApp</h1>
              <p className="text-lg opacity-90">Test your wallet connection and signing functionality</p>
            </div>
          </header>
          <main className="py-8">
            <NetworkToastHandler />
            <WalletTiles />
            {messagePort && (
              <HeyElsaChatWidget 
                position="bottom-right"
                messagePort={messagePort}
                keyId={WIDGET_KEY_ID}
                customStyles={{
                  primaryColor: "#D90013"
                }}
              />
            )}
          </main>
        </div>
      </ToastProvider>
    </WalletProvider>
  );
}

export default App;
